import React from "react";

import { Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./scrollToTop";
import { CartProvider, useCart } from "./CartContext";
import { ProductsProvider } from "./ProductsContext";
import { Footer } from "./Components/Footer/Footer";
import { TopNav } from "./Components/TopNav/TopNav";
import { MdOutlineVerticalAlignTop } from "react-icons/md";
import CartOffcanvas from "./Components/CartList/CartList";
import { CMSAuthProvider } from "./Contexts/CMSAuthContext";
import { CMSLogin } from "./Pages/CMS/CMSLogin";
import { CMSProtectedRoute } from "./Pages/CMS/CMSProtectedRoute";
import { CMSDashboard } from "./Pages/CMS/CMSDashboard";
import { CMSProducts } from "./Pages/CMS/CMSProducts";
import { CMSOrders } from "./Pages/CMS/CMSOrders";
import { CMSContacts } from "./Pages/CMS/CMSContacts";
import { CMSWholesale } from "./Pages/CMS/CMSWholesale";
import { CMSStock } from "./Pages/CMS/CMSStock";
import { CMSTestimonials } from "./Pages/CMS/CMSTestimonials";
import { CMSFlashInfo } from "./Pages/CMS/CMSFlashInfo";
import { CMSFAQs } from "./Pages/CMS/CMSFAQs";
import { CMSHomeSlides } from "./Pages/CMS/CMSHomeSlides";
import { CMSContactInfo } from "./Pages/CMS/CMSContactInfo";
import { CMSProfile } from "./Pages/CMS/CMSProfile";
import { CMSAdminUsers } from "./Pages/CMS/CMSAdminUsers";
import { PublicRoutes } from "./Pages/PublicRoutes";

function GlobalCart() {
  const {
    isOffCanvasOpen,
    closeCart,
    cart,
    removeFromCart,
    clearCart,
    incrementQuantity,
    decrementQuantity,
  } = useCart();

  return (
    <CartOffcanvas
      show={isOffCanvasOpen}
      onClose={closeCart}
      cart={cart}
      onRemoveFromCart={removeFromCart}
      onClearCart={clearCart}
      onIncrementQuantity={incrementQuantity}
      onDecrementQuantity={decrementQuantity}
    />
  );
}

function BackToTopButton() {
  const location = useLocation();
  const isCMSRoute = location.pathname.startsWith('/cms');
  
  if (isCMSRoute) {
    return null;
  }
  
  return (
    <div className="bck-to-top">
      <a href="#top">
        <MdOutlineVerticalAlignTop />
      </a>
    </div>
  );
}

function App() {
  return (
    <>
      {/* <SmoothScroll> */}
      <div id="top" />
      <CMSAuthProvider>
        <Routes>
          {/* CMS Routes */}
          <Route path="/cms/login" element={<CMSLogin />} />
          <Route
            path="/cms"
            element={
              <CMSProtectedRoute>
                <CMSDashboard />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/products"
            element={
              <CMSProtectedRoute>
                <CMSProducts />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/orders"
            element={
              <CMSProtectedRoute>
                <CMSOrders />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/contacts"
            element={
              <CMSProtectedRoute>
                <CMSContacts />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/wholesale"
            element={
              <CMSProtectedRoute>
                <CMSWholesale />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/stock"
            element={
              <CMSProtectedRoute>
                <CMSStock />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/testimonials"
            element={
              <CMSProtectedRoute>
                <CMSTestimonials />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/flash-info"
            element={
              <CMSProtectedRoute>
                <CMSFlashInfo />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/home-slides"
            element={
              <CMSProtectedRoute>
                <CMSHomeSlides />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/faqs"
            element={
              <CMSProtectedRoute>
                <CMSFAQs />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/contact-info"
            element={
              <CMSProtectedRoute>
                <CMSContactInfo />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/profile"
            element={
              <CMSProtectedRoute>
                <CMSProfile />
              </CMSProtectedRoute>
            }
          />
          <Route
            path="/cms/admin-users"
            element={
              <CMSProtectedRoute>
                <CMSAdminUsers />
              </CMSProtectedRoute>
            }
          />

          {/* Public Routes */}
          <Route
            path="/*"
            element={
              <ProductsProvider activeOnly={true}>
                <CartProvider>
                  <GlobalCart /> <ScrollToTop />
                  <TopNav />
                  <PublicRoutes />
                  <Footer />
                </CartProvider>
              </ProductsProvider>
            }
          />
        </Routes>
      </CMSAuthProvider>
      {/* </SmoothScroll> */}
      <BackToTopButton />
    </>
  );
}

export default App;
